var _circle, _path, _path2, _path3, _path4, _ellipse, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEnjoyNews(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#4909AA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.75 8.25L12.75 8.25",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.75 14.25L12 14.25",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.75 11.25L14.25 11.25",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.25 11.25V10.5C17.25 8.39331 17.25 7.33996 16.7444 6.58329C16.5255 6.25572 16.2443 5.97447 15.9167 5.75559C15.16 5.25 14.1067 5.25 12 5.25V5.25C9.89331 5.25 8.83996 5.25 8.08329 5.75559C7.75572 5.97447 7.47447 6.25572 7.25559 6.58329C6.75 7.33996 6.75 8.39331 6.75 10.5V13.5C6.75 15.6067 6.75 16.66 7.25559 17.4167C7.47447 17.7443 7.75572 18.0255 8.08329 18.2444C8.83996 18.75 9.89331 18.75 12 18.75V18.75",
    stroke: "white",
    strokeWidth: 2
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 16.125,
    cy: 16.125,
    rx: 1.875,
    ry: 1.875,
    stroke: "white",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.75 18.75L17.625 17.625",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnjoyNews);
export default __webpack_public_path__ + "static/media/EnjoyNews.2decd51b643c1d4e1bcc256a07e97b67.svg";
export { ForwardRef as ReactComponent };